export default {
  generalInformation: {
    title: 'Všeobecné informácie',
    company: 'Spoločnosť',
    street: 'Ulica',
    postalCode: 'PSČ',
    city: 'Mesto',
    state: 'Kraj',
    country: 'Krajina',
    email: 'E-mail',
    phone: 'Telefón',
    fax: 'Fax',
    cellPhone: 'Mobilný telefón',
  },
  contact: {
    firstName: 'Meno',
    lastName: 'Priezvisko',
    jobTitle: 'Pracovná pozícia',
    phone: 'Telefón 1',
    extensionPhone: 'Linka',
    secondPhone: 'Telefón 2',
    cellPhone: 'Mobilný telefón',
    privateMail: 'E-mail',
    addContact: 'Pridať kontakt',
  },
};
